export default {"src":"/_next/static/media/billiards.0e5f974c.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};